import Vue from 'vue'
import VueMarkdownEditor from '@kangc/v-md-editor'
import GoogleMapsWebGLPlugin from './google-maps-webgl-plugin';
import WindyPlugin from './WindyPlugin'; 
import { createPinia, PiniaVuePlugin } from 'pinia'
import ToastService from 'primevue/toastservice';
import VMdPreview from '@kangc/v-md-editor/lib/preview'
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js'
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import VueMeta from 'vue-meta'
import Prism from 'prismjs'
import hljs from 'highlight.js'
import PortalVue from 'portal-vue'
import PrimeVue from 'primevue/config';
import ptBR from './Lang/pt-BR'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue'
import { library as FontAwesomeLibrary } from '@fortawesome/fontawesome-svg-core'
import { far as FontAwesomeRegularIcons } from '@fortawesome/free-regular-svg-icons'
import { fas as FontAwesomeSolidIcons } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon as FontAwesomeIconComponent } from '@fortawesome/vue-fontawesome'
import '@kangc/v-md-editor/lib/style/base-editor.css'
import '@kangc/v-md-editor/lib/style/preview.css'
import '@kangc/v-md-editor/lib/theme/style/vuepress.css'
import '@kangc/v-md-editor/lib/theme/style/github.css'
import 'prismjs/components/prism-json'
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import { locale } from './configs';
import './primevue-components';  // Registra componentes adicionais do PrimeVue

VueMarkdownEditor.lang.add('pt-BR', ptBR)
VueMarkdownEditor.lang.use('pt-BR', ptBR)

VueMarkdownEditor.use(vuepressTheme, { Prism })

VMdPreview.use(githubTheme, { Hljs: hljs })

Vue.config.productionTip = false
const pinia = createPinia()
/* eslint-disable vue/component-definition-name-casing */
Vue.component('vue-multiselect', window.VueMultiselect.default)
Vue.component('font-awesome-icon', FontAwesomeIconComponent)
/* eslint-enable vue/component-definition-name-casing */

Vue.mixin({ methods: { route: window.route } })

Vue.use(PortalVue)
Vue.use(VueMarkdownEditor)
Vue.use(VMdPreview)
Vue.use(VueMeta)
Vue.use(PrimeVue, {
    locale
});
Vue.use(ToastService);
Vue.use(PiniaVuePlugin)
Vue.use(GoogleMapsWebGLPlugin, {
    apiKey: 'AIzaSyDEP0W1aRUiHh3K8izlwk7zUWj6-XyotxY',
});
Vue.use(WindyPlugin, {
    apiKey: '5xFhdwFu5PtGrivNp2y4p4CjejGzX7Sc' // Passe sua chave API aqui se necessário
  });

FontAwesomeLibrary.add(FontAwesomeRegularIcons, FontAwesomeSolidIcons)

InertiaProgress.init(
    {
        showSpinner: true,

    }
)

createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, app, props }) {
        new Vue({
            pinia,
            metaInfo: {
                titleTemplate: title => (title ? `${title} - Smart Destination` : 'Smart Destination'),
            },
            render: h => h(app, props),
        }).$mount(el)
    },
})
